export default {
  SET_ROOM_LIST_LOADING: Symbol('SET_ROOM_LIST_LOADING'),
  INIT_ROOM_LIST: Symbol('INIT_ROOM_LIST'),
  SET_ROOM_CARD_ENABLED: Symbol('SET_ROOM_CARD_ENABLED'),
  SET_ENABLED_VENDOR: Symbol('SET_ENABLED_VENDOR'),
};
